export default __webpack_public_path__ + "share-image.30c64758.png";